var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import isEqual from "lodash.isequal";
import TableRow from "../TableRow";
import TableCell, { MemoTableCell } from "../TableCell";
import CollapseRow from "../CollapseRow";
import TagRow from "../TagRow";
import { COLORS } from "../../../../../constants";
var TableRowContainer = function (_a) {
    var _b;
    var rowLength = _a.rowLength, columns = _a.columns, row = _a.row, memoCells = _a.memoCells, collapseRowClickHandler = _a.collapseRowClickHandler, columnData = _a.columnData, _c = _a.isFetching, isFetching = _c === void 0 ? false : _c, _d = _a.disableHover, disableHover = _d === void 0 ? false : _d, _e = _a.toolbarInside, toolbarInside = _e === void 0 ? false : _e;
    var CellComponent = memoCells ? MemoTableCell : TableCell;
    var _f = __read(useState(true), 2), open = _f[0], setOpen = _f[1];
    var _g = __read(useState(false), 2), hover = _g[0], setHover = _g[1];
    var canCollapse = columns.includes("collapse");
    var hasCheckbox = columns.includes("checkbox");
    var hasTags = (((_b = row === null || row === void 0 ? void 0 : row.tagsData) === null || _b === void 0 ? void 0 : _b.tags) || []).length > 0;
    // handle hover styles for all rows in group
    var onMouseEnter = function () {
        setHover(true);
    };
    var onMouseLeave = function () {
        setHover(false);
    };
    var bgcolor = null;
    if (row === null || row === void 0 ? void 0 : row.highlighted) {
        bgcolor = COLORS.SECONDARY_PRESSED;
    }
    else if (hover && !disableHover) {
        bgcolor = COLORS.SECONDARY_HOVER;
    }
    /**
     * deterimine which click handler to use column < row < cell
     */
    var getClickHandler = function (col) {
        var _a, _b;
        var rowData = row.rowData;
        var handler = ((_a = rowData[col]) === null || _a === void 0 ? void 0 : _a.clickHandler) ||
            (row === null || row === void 0 ? void 0 : row.clickHandler) ||
            ((_b = columnData[col]) === null || _b === void 0 ? void 0 : _b.clickHandler) ||
            undefined;
        if (columnData[col].style === "collapse") {
            return function (data) {
                if (typeof handler === "function") {
                    handler(__assign(__assign({}, data), { action: open ? "collapse" : "expand" }));
                }
                setOpen(!open);
            };
        }
        return handler;
    };
    var rowContent = (_jsx(TableRow, __assign({ onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, "data-testid": isFetching ? "loading-row" : "".concat(row === null || row === void 0 ? void 0 : row.id, "-row"), sx: {
            borderBottom: canCollapse || hasTags ? "none" : "1px solid ".concat(COLORS.P_OUTLINE),
            bgcolor: bgcolor,
            "&:last-child": {
                borderBottom: toolbarInside
                    ? "1px solid ".concat(COLORS.P_OUTLINE)
                    : "none",
            },
        } }, { children: columns.map(function (col) {
            var _a, _b, _c, _d, _e, _f;
            var clickHandler = isFetching ? null : getClickHandler(col);
            var colData = columnData[col];
            var cellData = (row === null || row === void 0 ? void 0 : row.rowData[col]) || {};
            /**
             * combine data from column row and cell in that order
             */
            var mergedData = __assign(__assign(__assign({}, colData), cellData), { tdBodyProps: __assign(__assign(__assign(__assign({}, colData === null || colData === void 0 ? void 0 : colData.tdBodyProps), (((_a = row === null || row === void 0 ? void 0 : row.rowData[col]) === null || _a === void 0 ? void 0 : _a.tdBodyProps) || {})), cellData === null || cellData === void 0 ? void 0 : cellData.tdBodyProps), { textProps: __assign(__assign(__assign({}, (_b = colData === null || colData === void 0 ? void 0 : colData.tdBodyProps) === null || _b === void 0 ? void 0 : _b.textProps), (((_d = (_c = row === null || row === void 0 ? void 0 : row.rowData[col]) === null || _c === void 0 ? void 0 : _c.tdBodyProps) === null || _d === void 0 ? void 0 : _d.textProps) || {})), (_e = cellData === null || cellData === void 0 ? void 0 : cellData.tdBodyProps) === null || _e === void 0 ? void 0 : _e.textProps) }) });
            return (_jsx(CellComponent, { hover: hover, data: (row === null || row === void 0 ? void 0 : row.data) || {}, columnName: col, content: (_f = row === null || row === void 0 ? void 0 : row.rowData[col]) === null || _f === void 0 ? void 0 : _f.content, collapseOpen: open, cellId: isFetching ? "loading-cell" : row.id, cellData: mergedData, clickHandler: clickHandler || undefined, hasTags: hasTags, isFetching: isFetching }, col));
        }) })));
    return (_jsxs(_Fragment, { children: [rowContent, !isFetching && (_jsxs(_Fragment, { children: [_jsx(TagRow, { tagsData: row.tagsData, rowId: row.id, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, bgcolor: bgcolor, hasCheckbox: hasCheckbox }), _jsx(CollapseRow, { canCollapse: canCollapse, row: row, rowLength: rowLength, memoCells: memoCells, collapseRowClickHandler: collapseRowClickHandler, open: open })] }))] }));
};
/* istanbul ignore next */
export default React.memo(TableRowContainer, function (prev, next) {
    if (!isEqual(prev, next)) {
        return false;
    }
    return true;
});
